import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class TaxConsultancy extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container">
          <div class="container-fluid" data-aos="fade-up">
             <div class="section-header">
              <h3>Tax Consultancy</h3>
              <p>  ClipTax consults on Tax Cases like IT Declaration, Tax Savings,
                Late Income Tax Filing, Revised Income Tax Filing, Optimal
                Salary Structure, Startup Salary, Capital Gains, Re-investment
                Options, Undisclosed Income, Tax Investigations, Handling IT
                Notice, IT Audit, GST, GST Filing, GST Audit, Export, Import
                Businesses etc are some examples where we can help you with
                Utmost ease.</p>
            </div>
           
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default TaxConsultancy;
